import { useState } from 'react'

import { PortfolioPanel } from '@/modules/projects'
import type { MonthKey } from '@/modules/projects/components/portfolio/model/types'

// The As of month and the chosen account live here, so the top half and the detail half agree.
export function ProjectPortfolioPage() {
  const [month, setMonth] = useState<MonthKey | null>(null)
  const [selectedAccountId, setSelectedAccountId] = useState<string | null>(
    null,
  )

  return (
    <PortfolioPanel
      month={month}
      onMonthChange={setMonth}
      selectedAccountId={selectedAccountId}
      onSelectAccount={setSelectedAccountId}
    />
  )
}
